export const PHOTOGRAPHER_AVAILABILITIES_IS_FETCHING = 'PHOTOGRAPHER_AVAILABILITIES_IS_FETCHING';
export const PHOTOGRAPHER_AVAILABILITIES_FETCH_SUCCESS = 'PHOTOGRAPHER_AVAILABILITIES_FETCH_SUCCESS';
export const PHOTOGRAPHER_AVAILABILITIES_FETCH_FAILURE = 'PHOTOGRAPHER_AVAILABILITIES_FETCH_FAILURE';

export const PHOTOGRAPHER_AVAILABILITIES_SELECT_SLOT = 'PHOTOGRAPHER_AVAILABILITIES_SELECT_SLOT';
export const PHOTOGRAPHER_AVAILABILITIES_UNSELECT_SLOT = 'PHOTOGRAPHER_AVAILABILITIES_UNSELECT_SLOT';

export const PHOTOGRAPHER_AVAILABILITIES_SELECT_CATEGORY = 'PHOTOGRAPHER_AVAILABILITIES_SELECT_CATEGORY';
export const PHOTOGRAPHER_AVAILABILITIES_SELECT_PACKAGE = 'PHOTOGRAPHER_AVAILABILITIES_SELECT_PACKAGE';



// WEBPACK FOOTER //
// ./engines/vcliq_booking/app/assets/javascripts/vcliq_booking/components/availabilityTimetableForm/events.js